import pick from "lodash.pick";
import vars from '../utils/vars';
import {TYPE_BUNDLE, TYPE_CASE} from "../contants/common";

export const checkIsBundle = type => type === 'bundle';
export const makeConfiguratorLink = id => `https://www.mifcom.de/${id}?configurator`;
export const formatItems = items => items.map(item => {
	const id = String(item.productId || item.bundleId);
	const src = item.src.optimized || item.src.png;
	return {
		id,
		type: item.type /*=== TYPE_CASE ? TYPE_BUNDLE : item.type*/,
		src,
		srcDetail: checkIsBundle(item.type)
			? `/products/details/${id}.png`
			: src,
		price: Number(item.basePrice || item.price),
		title: item.title,
		titleShort: item.titleShort || item.title,
	}
});
export const isSmallDevice = (width = window.innerWidth) => {
	return width / 16 <= Number(vars.devicesEdge)
};
export const formatIndex = index => index.toLocaleString().replace(/,/g, '.');
export const reduceOptions = (selectedArray, options) => {
	return selectedArray.reduce((acc, selectedItem) => {
		const id = typeof selectedItem === 'string' ? selectedItem : selectedItem?.id;
		/* Does not support multi selections */
		const option = options.find(item => item.productId === id);
		if (option) {
			acc[option.type] = id;
		}
		return acc;
	}, {});
}

function toggleFullScreen(el, flag) {
	var doc = window.document;
	var docEl = el || doc.documentElement;
	
	if(flag) {
		document.querySelector('body').classList.add('fullscreen');
	} else {
		document.querySelector('body').classList.remove('fullscreen');
	}
	
	var requestFullScreen =
		docEl.requestFullscreen ||
		docEl.mozRequestFullScreen ||
		docEl.webkitRequestFullScreen ||
		docEl.msRequestFullscreen;
	var cancelFullScreen =
		doc.exitFullscreen ||
		doc.mozCancelFullScreen ||
		doc.webkitExitFullscreen ||
		doc.msExitFullscreen;
	
	if (
		!doc.fullscreenElement &&
		!doc.mozFullScreenElement &&
		!doc.webkitFullscreenElement &&
		!doc.msFullscreenElement
	) {
		requestFullScreen.call(docEl);
	} else {
		cancelFullScreen.call(doc);
	}
}

export const openFullscreen = (el) => toggleFullScreen(el, true);
export const closeFullscreen = () => toggleFullScreen(undefined, false);

export const getHTMLElementHeight = el => {
	let style = window.getComputedStyle(el);
	return [
		'height',
		'padding-top',
		'padding-bottom',
		'margin-top',
		'margin-bottom',
		'border-bottom',
		'border-top',
	]
		.map((key) => parseInt(style.getPropertyValue(key), 10))
		.reduce((prev, cur) => prev + cur);
}

export const isHardCoded = productId => ~productId.indexOf('hardcode');
export const removeFirstAndLastChar = s => s.slice(1, s.length - 1);